<template>
    <div>
      <b-modal
        id="detail-role-modal"
        no-close-on-backdrop
        size="lg"
        title="Detail Role"
      >
        <b-row>
          <b-col cols="12" xl="12">
            <table class="table table-bordered table-sm table-striped">
              <tbody>
                <tr>
                  <th><span class="font-weight-bold">Nama Role</span></th>
                  <td>{{ result.roleName }}</td>
                </tr>
                <tr>
                  <th><span class="font-weight-bold">Kode Role</span></th>
                  <td>{{ result.roleCode }}</td>
                </tr>
                <tr>
                  <th><span class="font-weight-bold">Tipe Role</span></th>
                  <td>{{ result.isAdmin ? `Admin`: `Non Admin` }}</td>
                </tr>
              </tbody>
            </table>
            <div v-for="(item, index) in result.uiComponents" :key="index">
              <b-form-checkbox :disabled="true" :checked="true">{{ item.uiName }}</b-form-checkbox>
            </div>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </template>

  <script>
  import { BCol, BAvatar, BRow, BFormCheckbox } from "bootstrap-vue";

  export default {
    components: {
      BCol,
      BAvatar,
      BRow,
      BFormCheckbox
    },
    // eslint-disable-next-line vue/require-prop-types
    props: ["result"],
  };
  </script>
